module.exports = __webpack_public_path__ + "static/media/cid11.c8a3f2a6.svg";